<template>

<div id="" class="leftmenu influencer-single" v-if="influencer && !is_fetching_content">


    <router-link v-if="!lastRoute" :to="'/social'" class="lm-link lm-backbtn trigger-nav-back">
        Back
    </router-link>
    <a v-if="lastRoute" href="javascript:history.go(-1)" class="lm-link lm-backbtn trigger-nav-back">
        Back        
    </a>

    

    <h1 class="lm-h1">
        <span class="styled">
            {{influencer.first_name}}
        </span>
        <span class="straight">
            {{influencer.last_name}}
        </span>
    </h1>

    <div class="text wysiwyg-content" v-if="influencer.bio_text" v-html="influencer.bio_text" @click="handleDynamicHtmlClicks($event)"></div>


    <template v-if="influencer.instagram_link">
		<br><br>
        <a :href="influencer.instagram_link" target="_blank" class="nicelink">
            Instagram
        </a>
    </template>

    <template v-if="influencer.facebook_link">
        <br><br>
		<a :href="influencer.facebook_link" target="_blank" class="nicelink">
            Facebook
        </a>
    </template>


    

    <template v-if="loggedin_user && false">

        <br><br>

        <router-link class="lm-link lvl1" :to="'/admin'">Admin</router-link><br>
        <router-link class="lm-link lvl1" :to="'/admin/influencer/'+influencer.id">Edit {{influencer.first_name}}</router-link><br>        

    </template>

</div>

</template>
<script>
import mixins from '.././mixins.js'


export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		
	},

	data(){ return {                            
        
	}},


	computed: {

        influencer(){ return this.$store.state.loaded_influencer },
        
        lastRoute(){ return this.$store.state.route.previous[1] },

	},

	methods: {

		goBack(){
			this.$router.go( -1 )
		},

	},

	created(){
		
	},

}
</script>



// WEBPACK FOOTER //
// src/views/LeftMenuInfluencer.vue